<script setup lang="ts">
import Box from '@uiKit/elements/Box.vue'
import Text from '@uiKit/elements/Text.vue'
import PiIcon from '@uiKit/elements/PiIcon.vue'

// Inline informational notice that replaces a financial-action region (Add
// funds / Withdraw) while the investor's KYC is submitted and awaiting review.
// Unlike KycActionBlocker there is no CTA — the only thing the investor can do
// is wait, so an action button would be misleading. Calm info tone (not the
// amber action-required tone) signals "in progress, nothing for you to do".
// Parents render this conditionally — it does not self-gate.
interface Props {
  title?: string
  description?: string
}

withDefaults(defineProps<Props>(), {
  title: 'Verification in progress',
  description:
    "We're reviewing your identity. Adding funds and withdrawals unlock automatically once you're verified — no further action needed.",
})
</script>

<template>
  <Box direction="col" align="center" gap="3" class="kyc-review">
    <Box align="center" justify="center" class="kyc-review__icon">
      <PiIcon name="clock" />
    </Box>
    <Box direction="col" gap="1" align="center">
      <Text type="subheading" weight="semibold" align="center">{{ title }}</Text>
      <Text type="body-sm" color="muted" align="center">{{ description }}</Text>
    </Box>
  </Box>
</template>

<style scoped>
.kyc-review {
  width: 100%;
  box-sizing: border-box;
  padding: 1.25rem;
  background: var(--p-info-50);
  border: 1px solid var(--p-info-200);
  border-radius: var(--p-border-radius-lg);
}

.kyc-review__icon {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  flex-shrink: 0;
  font-size: 1rem;
  background: var(--p-info-100);
  color: var(--p-info-700);
}
</style>
